import React from 'react'
import { Grid } from "@mui/material";
import { UiInputGroupWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import TargetsTable from './TargetsTable';
import Stack from '@mui/material/Stack';
import {
    UiButton, UiIconButton
} from "../../../../../_uiComponents/common/form/UiButton";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UiFileUploader from '../../../../../_uiComponents/common/form/UiFileUploader';

export default function Targets(props) {

    return (
        <>
            <UiInputGroupWr
                title="Targets"
            >
                <Grid container spacing={2} sx={{ mb: 1 }}>
                    <Grid
                        item
                        xs="12"
                        lg="12"
                    >
                        <div className='sba-download-templates'>
                            <h5>Download Templates</h5>
                            <UiIconButton name="Templates" variant="contained" size="small" color="primary" icon={<FileDownloadIcon />} />
                        </div>

                    </Grid>
                    <Grid
                        item
                        xs="12"
                        lg="6"
                    >
                        <div className='sba-download-templates'>
                            <h5>File Upload</h5>
                            <UiFileUploader />
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs="12"
                        lg="12"
                    >

                        <TargetsTable />

                    </Grid>
                    <Grid item xs="12" lg="12" sx={{ mb: 2, mt: 3 }} >
                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%' }}>
                            <UiButton name="Clear" variant="outlined" size="small" />
                            <UiButton name="Save" variant="contained" size="small" />
                        </Stack>
                    </Grid>
                </Grid>

            </UiInputGroupWr>

        </>
    )
}
